import { useQuery } from "@tanstack/react-query";
import type { BalanceHistory } from "../types";
import { getBalanceHistory } from "../api";

export const useBalanceHistory = (
  page: number = 1, // Default value for page
  page_size: number = 1000, // Default value for page_size
  role?: string | null // Optional role parameter
) => {
  return useQuery<BalanceHistory[], Error>({
    queryKey: ["balanceHistory", page, page_size, role], // Include role in the query key
    queryFn: () => {
      // Only call the backend if the role is "owner"
      if (role === "owner") {
        return getBalanceHistory(page, page_size);
      }
      // Return an empty array or null if the role is not "owner"
      return Promise.resolve([]);
    },
    enabled: role === "owner", // Only enable the query if the role is "owner"
  });
};
